import React, { useState, useEffect, useContext } from 'react';
import StoreContext from "../../StoreContext";

const InstallPrompt = () => {
    const storeContext = useContext(StoreContext);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [isStandalone, setIsStandalone] = useState(false);
    const [modifiedLightColor, setModifiedLightColor] = useState(false);

    useEffect(() => {
        const match = storeContext.color.match(/\d+/g);
        if (match && match.length === 3) {
            const [red, green, blue] = match;
            setModifiedLightColor(`rgba(${red}, ${green}, ${blue}, 0.6)`);
        }

        const checkIfInstalled = () => {
            const userAgent = window.navigator.userAgent;
            const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

            const isSafari = isIOSDevice && /^((?!CriOS|FxiOS|EdgiOS).)*Safari/.test(userAgent);

            setIsIOS(isIOSDevice);

            // Prevent if not Safari
            if (isIOSDevice && !isSafari) {
                return;
            }

            // Check if already installed
            if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
                setIsStandalone(true);
                return;
            }

            if (isIOSDevice && window.navigator.standalone) {
                setIsStandalone(true);
                return;
            }

            const hasDismissed = localStorage.getItem('installPromptDismissed');
            if (hasDismissed) {
                return;
            }

            setTimeout(() => {
                setShowInstallPrompt(true);
            }, 3000);
        };

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstallPrompt(true);
        };

        const handleAppInstalled = () => {
            setShowInstallPrompt(false);
            setDeferredPrompt(null);
            console.log('PWA was installed');
        };

        checkIfInstalled();

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                console.log('User accepted the install prompt');
            } else {
                console.log('User dismissed the install prompt');
            }
            setDeferredPrompt(null);
            setShowInstallPrompt(false);
        }
    };

    const handleDismiss = () => {
        setShowInstallPrompt(false);
        localStorage.setItem('installPromptDismissed', 'true');
    };

    const handleIOSInstall = () => {
        setShowInstallPrompt(false);
        localStorage.setItem('installPromptDismissed', 'true');
    };

    if (isStandalone || !showInstallPrompt) {
        return null;
    }

    return (
        <div className="install-prompt-overlay" style={{ backgroundColor: `${storeContext.color}` }} id="install-prompt-overlay">
            <div className="install-prompt">
                <div className="install-prompt-header">
                    <h5>
                        <span style={{ marginRight: '8px' }}>🚀</span>
                        Install {storeContext.name}
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleDismiss}
                        aria-label="Close"
                        style={{ background: `${modifiedLightColor}`, color: "white" }}
                    >
                        ✕
                    </button>
                </div>

                <div className="install-prompt-body">
                    {isIOS ? (
                        <div className="ios-install">
                            {/* <p>
                                <span style={{ fontSize: '1.2em', marginRight: '8px' }}>⚡</span>
                                Add {storeContext.name} to your home screen for quick access!
                            </p> */}

                            <div className="ios-instructions">
                                <strong className='install'>📋 To install:</strong>
                                <ol>
                                    <li>Tap <strong>'Share'</strong> button at bottom of broswer</li>
                                    <li>Scroll down and tap <strong>'Add to Home Screen'</strong></li>
                                    <li>Tap <strong>'Add'</strong> to finish</li>
                                </ol>
                            </div>


                            <div className="install-actions">
                                <button
                                    className="btn install-btn"
                                    style={{ backgroundColor: `${modifiedLightColor}` }}
                                    onClick={handleIOSInstall}
                                >
                                    <span style={{ marginRight: '4px' }}>✅</span>
                                    Got it!
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="android-install">
                            {/* <p>
                                <span style={{ fontSize: '1.2em', marginRight: '8px' }}>⚡</span>
                                Add {storeContext.name} to your home screen for quick access!
                            </p> */}

                            <div className='android-intructions'>
                                <strong className='install'>🎯 What you'll get:</strong>
                                <ol>
                                    <li>Faster loading times</li>
                                    <li>Native app-like experience</li>
                                    <li>Quick home screen access</li>
                                </ol>
                            </div>

                            <div className="install-actions">
                                <button
                                    className="btn dismiss-btn"
                                    onClick={handleDismiss}
                                >
                                    Maybe later
                                </button>
                                <button
                                    className="btn install-btn"
                                    style={{ backgroundColor: `${modifiedLightColor}` }}
                                    onClick={handleInstallClick}
                                >
                                    <span style={{ marginRight: '6px' }}>📲</span>
                                    Install App
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InstallPrompt; 